<template>
  <div class="filed is-centered">
    <div class="control">
      <RouterLink
        class="button is-text is-white is-inverted"
        :to="{ name: 'ForgottenPassword' }"
      >
        ¿olvidaste tu contraseña?
      </RouterLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkForgottenPassword',
};
</script>
